module.exports = __webpack_public_path__ + "img/no_data.54ef03e4.svg";